import { API_BASE_URL } from "../../config"
import request from "../../utilities/request"

const deleteAmpCategory = (categoryId) => request.delete(`${API_BASE_URL}/blockchain/category/${categoryId}`)

export default deleteAmpCategory